import React, { useState } from 'react';
import { Phone, MapPin, Instagram, Facebook } from 'lucide-react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [openModal, setOpenModal] = useState<null | 'privacy' | 'terms'>(null);
  return <footer className="bg-black border-t border-gold/20 pt-16 pb-8" data-id="element-160" data-mp="32pfci3q053uh">
      <div className="container mx-auto px-4 md:px-6" data-id="element-161" data-mp="36qhgsyys063b">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-162" data-mp="36n3bbhutfgrn">
          {/* Logo & About */}
          <div className="space-y-6" data-id="element-163" data-mp="38qvoyiyxrr6">
            <img src="https://cdn.magicpatterns.com/uploads/6U8Zqe8m1fPZcxDL2DDpsS/logorendcelebrate.png" alt="Celebrate Your Party Logo" loading="lazy" decoding="async" className="h-36 md:h-40 w-auto -my-4" style={{
            WebkitMaskImage: 'radial-gradient(circle at center, black 50%, transparent 54%)',
            maskImage: 'radial-gradient(circle at center, black 50%, transparent 54%)'
          }} data-id="element-164" data-mp="37o5ytxdtvcu" />
            <p className="text-cream/70 font-light text-sm max-w-xs" data-id="element-165" data-mp="3gagyrmubl72o">
              Cada evento cuenta una historia. Nosotros estamos aquí para
              capturarla. Lujo, elegancia y recuerdos eternos para la comunidad
              hispana.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-166" data-mp="82qsbsqetttq">
            <h4 className="text-gold font-serif font-semibold text-lg mb-6" data-id="element-167" data-mp="82ihs7hrf0lp">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-3" data-id="element-168" data-mp="335rtdvlddew">
              <li data-id="element-169" data-mp="3231p863ff01">
                <a href="#inicio" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-170" data-mp="hsk2cpawm0vv">
                  Inicio
                </a>
              </li>
              <li data-id="element-171" data-mp="qsqf28ys2wtz">
                <a href="#servicio" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-172" data-mp="qub8twd9qbqs">
                  El Servicio
                </a>
              </li>
              <li data-id="element-173" data-mp="tt090qdpumqh">
                <a href="#testimonios" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-174" data-mp="yu7hkrnonpy7">
                  Testimonios
                </a>
              </li>
              <li data-id="element-175" data-mp="18k93bcskcw9y">
                <a href="#preguntas" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-176" data-mp="18ksmsxxv3sq3">
                  Preguntas Frecuentes
                </a>
              </li>
              <li data-id="element-177" data-mp="1hmidu2nu0pnc">
                <a href="#reservar" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-178" data-mp="1mk1s32kj52fa">
                  Reservar Fecha
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-179" data-mp="3ta89phtymxag">
            <h4 className="text-gold font-serif font-semibold text-lg mb-6" data-id="element-180" data-mp="3t9ym20we127x">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-181" data-mp="2afdh79cf72n7">
              <li data-id="element-182" data-mp="2agey3ug4ajcu">
                <a href="tel:+14049409785" className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-183" data-mp="2agybcxutojkj">
                  <Phone className="w-4 h-4" data-id="element-184" data-mp="21kfn3yxjdjua" />
                  <span data-id="element-185" data-mp="1woi9i0dnqrl7">(404) 940-9785</span>
                </a>
              </li>
              <li data-id="element-186" data-mp="2tehpuh01uuec">
                <a href="tel:+16784721588" className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-187" data-mp="2tcy8en2nqdaz">
                  <Phone className="w-4 h-4" data-id="element-188" data-mp="2kci97psy5sbx" />
                  <span data-id="element-189" data-mp="2kfe5zat26ays">(678) 472-1588</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-cream/70 text-sm" data-id="element-190" data-mp="2fdorfl6mnf5y">
                <MapPin className="w-4 h-4 shrink-0 mt-0.5" data-id="element-191" data-mp="18z5z4x6lgdhb" />
                <span data-id="element-192" data-mp="13z1jf9difms5">Atlanta, GA y área metropolitana</span>
              </li>
              <li data-id="element-193" data-mp="1414jkm8dmwal">
                <a href="https://instagram.com/celebrateyp" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gold hover:text-gold-light transition-colors text-sm font-medium" data-id="element-194" data-mp="2rvr8xjexswhg">
                  <Instagram className="w-4 h-4" data-id="element-195" data-mp="2nu5ptgbt7lyt" />
                  <span data-id="element-196" data-mp="2nuxh4eydixja">@celebrateyp</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-197" data-mp="3bhm4hg65ji7a">
          <p className="text-cream/50 text-xs text-center md:text-left" data-id="element-198" data-mp="31lj6mmic25q5">
            © {new Date().getFullYear()} Celebrate Events · Atlanta, GA. Todos
            los derechos reservados.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs" data-id="element-199" data-mp="1q6druk4xggq6">
            <button onClick={() => setOpenModal('privacy')} className="text-cream/60 hover:text-gold transition-colors" data-id="element-200" data-mp="1v5gwi3gzwkxm">
              Política de Privacidad
            </button>
            <span className="text-cream/20" data-id="element-201" data-mp="1ine7ab5qcj58">·</span>
            <button onClick={() => setOpenModal('terms')} className="text-cream/60 hover:text-gold transition-colors" data-id="element-202" data-mp="1iml4tmdt0fsw">
              Términos y Condiciones
            </button>
          </div>

          <div className="flex items-center gap-4" data-id="element-203" data-mp="13xp1g2mozqym">
            <a href="https://instagram.com/celebrateyp" target="_blank" rel="noopener noreferrer" aria-label="Instagram @celebrateyp" className="text-gold hover:text-gold-light transition-colors hover:drop-shadow-[0_0_8px_rgba(212,175,55,0.6)]" data-id="element-204" data-mp="13yi4asij5wbh">
              <Instagram className="w-5 h-5" data-id="element-205" data-mp="18v8itbeosjus" />
            </a>
            <a href="#" aria-label="Facebook" className="text-cream/50 hover:text-gold transition-colors" data-id="element-206" data-mp="l5w8u9bjc7rf">
              <Facebook className="w-5 h-5" data-id="element-207" data-mp="2gb5eprl6lhlw" />
            </a>
          </div>
        </div>
      </div>

      {/* Privacy Modal */}
      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-208" data-mp="2l8f9lmrcalh4">
        <p className="text-xs text-cream/50 uppercase tracking-wide" data-id="element-209" data-mp="2uzjnsk96y2aw">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p data-id="element-210" data-mp="22b4ac25pjs1o">
          En <strong data-id="element-211" data-mp="22cp77yfhvn2p">Celebrate Events</strong> valoramos profundamente tu
          privacidad y la confianza que depositas en nosotros al compartir tus
          datos personales. Esta política describe cómo recopilamos, usamos y
          protegemos tu información.
        </p>

        <h3 data-id="element-212" data-mp="3ioujvoflj8ip">1. Información que recopilamos</h3>
        <p data-id="element-213" data-mp="3mq6c81puu7ul">
          Cuando contactas con nosotros o reservas un evento, podemos solicitar:
        </p>
        <ul data-id="element-214" data-mp="1b3vqz0agoq89">
          <li data-id="element-215" data-mp="1b2awfao5d7ae">
            Nombre completo y datos de contacto (teléfono, correo electrónico).
          </li>
          <li data-id="element-216" data-mp="17324mbco3jhh">
            Información del evento (fecha, ubicación, tipo de celebración).
          </li>
          <li data-id="element-217" data-mp="129r3mqujdwxh">
            Fotografías y contenido tomado durante el evento con nuestro Mirror
            Photo Booth.
          </li>
          <li data-id="element-218" data-mp="xa4r6jmj8kpq">Mensajes y comunicaciones que intercambies con nosotros.</li>
        </ul>

        <h3 data-id="element-219" data-mp="sarwjcpf69cl">2. Cómo usamos tu información</h3>
        <ul data-id="element-220" data-mp="ndi922llc7re">
          <li data-id="element-221" data-mp="ncqaciwp5tww">Para confirmar y coordinar la reserva de tu evento.</li>
          <li data-id="element-222" data-mp="jbwmtqn62h4j">
            Para brindarte atención personalizada antes, durante y después del
            servicio.
          </li>
          <li data-id="element-223" data-mp="ee4vaxqfox0v">
            Para enviarte una galería digital de las fotos tomadas en tu evento.
          </li>
          <li data-id="element-224" data-mp="2dpp8eiiolwsw">
            Para mejorar nuestros servicios y comunicarnos contigo sobre
            promociones (solo si lo autorizas).
          </li>
        </ul>

        <h3 data-id="element-225" data-mp="1hl8onavo87z6">3. Compartir información con terceros</h3>
        <p data-id="element-226" data-mp="1hnv5y28d61ul">
          <strong data-id="element-227" data-mp="1ho4lswzp2smk">Nunca vendemos ni alquilamos tus datos personales.</strong>{' '}
          Solo compartimos información cuando es estrictamente necesario para
          prestar el servicio (por ejemplo, con proveedores de impresión o
          almacenamiento de galerías), bajo estrictas obligaciones de
          confidencialidad.
        </p>

        <h3 data-id="element-228" data-mp="yu7q2nygqeg5">4. Uso de fotografías</h3>
        <p data-id="element-229" data-mp="yxdfk4b07ice">
          Las fotografías tomadas en tu evento son tuyas y de tus invitados.
          Podríamos solicitar tu autorización por escrito para usar algunas de
          ellas en nuestro portafolio o redes sociales. Si no deseas que las
          usemos, simplemente avísanos y respetaremos tu decisión.
        </p>

        <h3 data-id="element-230" data-mp="2jb48lpmum07c">5. Seguridad de los datos</h3>
        <p data-id="element-231" data-mp="2jc5k1v7s0opl">
          Implementamos medidas técnicas y organizativas razonables para
          proteger tu información contra acceso no autorizado, pérdida o
          alteración.
        </p>

        <h3 data-id="element-232" data-mp="cnwxgn2alezu">6. Tus derechos</h3>
        <p data-id="element-233" data-mp="cn4zj5l8356e">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento. Para ejercer estos derechos, contáctanos al{' '}
          <a href="tel:+14049409785" data-id="element-234" data-mp="mdggpttx3av8">(404) 940-9785</a>.
        </p>

        <h3 data-id="element-235" data-mp="hm83empgv5cs">7. Cambios a esta política</h3>
        <p data-id="element-236" data-mp="hkdllh9hrtcx">
          Podemos actualizar esta política ocasionalmente. La fecha de última
          actualización aparece al inicio del documento.
        </p>

        <h3 data-id="element-237" data-mp="qeryxeagotte">8. Contacto</h3>
        <p data-id="element-238" data-mp="qdgst7tjn9z4">
          Si tienes preguntas sobre cómo manejamos tu información, escríbenos o
          llámanos. Estamos para servirte — en tu idioma, con respeto y
          transparencia.
        </p>
      </LegalModal>

      {/* Terms Modal */}
      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-239" data-mp="372w2ubi6ybej">
        <p className="text-xs text-cream/50 uppercase tracking-wide" data-id="element-240" data-mp="324uhtl17g20f">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p data-id="element-241" data-mp="8vj22un1tseh">
          Al contratar los servicios de <strong data-id="element-242" data-mp="8wkotwdfg3c1">Celebrate Events</strong>,
          aceptas los siguientes términos y condiciones. Por favor léelos con
          atención.
        </p>

        <h3 data-id="element-243" data-mp="11kghmpzvlb3j">1. Servicios</h3>
        <p data-id="element-244" data-mp="11joqbrdb9zj2">
          Celebrate Events ofrece el alquiler del Mirror Photo Booth y servicios
          relacionados (instalación, atendente, impresión, diseño personalizado,
          fondo decorativo y galería digital) para eventos sociales y
          corporativos en el área metropolitana de Atlanta, GA.
        </p>

        <h3 data-id="element-245" data-mp="mvk267vhovsw">2. Reserva de fecha</h3>
        <ul data-id="element-246" data-mp="1kb7sjvzih9k1">
          <li data-id="element-247" data-mp="1kbr8x89ijpvy">
            La fecha del evento se considera reservada únicamente al recibir el
            depósito acordado.
          </li>
          <li data-id="element-248" data-mp="1fiy5qotp0plz">
            Recomendamos reservar con un mínimo de 4 a 8 semanas de
            anticipación.
          </li>
          <li data-id="element-249" data-mp="1nvhxs6u41fip">
            Las fechas en temporada alta (mayo, junio, octubre y diciembre) se
            agotan rápido y se reservan por orden de llegada.
          </li>
        </ul>

        <h3 data-id="element-250" data-mp="1wsiio3hz0vhe">3. Pagos</h3>
        <ul data-id="element-251" data-mp="21swr3mnhi7fy">
          <li data-id="element-252" data-mp="21sn2a2e6e6bu">
            Se requiere un depósito para asegurar la fecha. El monto se acuerda
            al firmar el contrato.
          </li>
          <li data-id="element-253" data-mp="26rhs3oak8v5g">
            El saldo restante debe pagarse antes del inicio del evento, salvo
            acuerdo distinto.
          </li>
          <li data-id="element-254" data-mp="2fkbb9wt4oeol">Aceptamos efectivo, transferencia electrónica y Zelle.</li>
        </ul>

        <h3 data-id="element-255" data-mp="2fme7wzosd62a">4. Cancelaciones y reprogramaciones</h3>
        <ul data-id="element-256" data-mp="2kicssdawo5xy">
          <li data-id="element-257" data-mp="2ki33yt1lk4tu">
            Las cancelaciones realizadas con más de 30 días de anticipación
            pueden recibir reembolso parcial del depósito, sujeto a evaluación.
          </li>
          <li data-id="element-258" data-mp="2uin8c4kexpga">
            Las cancelaciones con menos de 30 días pierden el depósito por
            costos administrativos y de reserva.
          </li>
          <li data-id="element-259" data-mp="24r3s0399e7x6">
            Las reprogramaciones están sujetas a disponibilidad y se gestionan
            sin costo adicional cuando se solicitan con anticipación razonable.
          </li>
        </ul>

        <h3 data-id="element-260" data-mp="29sjb3prvm4cx">5. Responsabilidades del cliente</h3>
        <ul data-id="element-261" data-mp="29rrdk9epxwk0">
          <li data-id="element-262" data-mp="29qyi44l7mth6">
            Proveer un espacio adecuado para el espejo (mínimo recomendado: 3m x
            3m) con acceso a toma de corriente eléctrica.
          </li>
          <li data-id="element-263" data-mp="2ilmjhjnnzr0p">
            Garantizar el trato respetuoso de nuestro equipo y atendente durante
            el evento.
          </li>
          <li data-id="element-264" data-mp="2xhcaxxbmcwct">
            Cubrir el costo de reparación o reposición en caso de daño causado
            por invitados al equipo.
          </li>
        </ul>

        <h3 data-id="element-265" data-mp="133b0sgamcmxf">6. Responsabilidades de Celebrate Events</h3>
        <ul data-id="element-266" data-mp="13671gcdupppk">
          <li data-id="element-267" data-mp="y4zs48w28igs">
            Llegar a tiempo e instalar el equipo antes del inicio del evento.
          </li>
          <li data-id="element-268" data-mp="39slet3hfevr2">
            Operar el espejo y asistir a los invitados durante toda la duración
            contratada.
          </li>
          <li data-id="element-269" data-mp="3eqem5zugtvsx">
            Entregar fotos impresas de calidad profesional al instante,
            personalizadas con el nombre y fecha del evento.
          </li>
          <li data-id="element-270" data-mp="351d3u30g72bs">
            Compartir la galería digital con el cliente dentro de los días
            posteriores al evento.
          </li>
        </ul>

        <h3 data-id="element-271" data-mp="2r0ai5rdd7u1e">7. Limitación de responsabilidad</h3>
        <p data-id="element-272" data-mp="2v3767xlocicq">
          Celebrate Events no se hace responsable por interrupciones causadas
          por fallas en el suministro eléctrico del lugar, condiciones
          climáticas extremas (en eventos al aire libre sin protección adecuada)
          o circunstancias fuera de nuestro control. En tales casos trabajaremos
          con el cliente para minimizar el impacto.
        </p>

        <h3 data-id="element-273" data-mp="kbdxfxz1x1ba">8. Uso de las fotografías</h3>
        <p data-id="element-274" data-mp="kackfnyh64qx">
          Las fotos tomadas durante el evento pertenecen al cliente y sus
          invitados. Celebrate Events puede solicitar autorización para mostrar
          algunas en su portafolio o redes sociales. El cliente puede rechazar
          este uso sin penalización.
        </p>

        <h3 data-id="element-275" data-mp="27ct0kgnksyrr">9. Modificaciones</h3>
        <p data-id="element-276" data-mp="27c15r81sz52j">
          Estos términos pueden actualizarse en cualquier momento. La versión
          aplicable a tu evento será la vigente a la fecha de tu contrato.
        </p>

        <h3 data-id="element-277" data-mp="1xgg3r9wqi4ss">10. Jurisdicción</h3>
        <p data-id="element-278" data-mp="1xhixdplfylce">
          Cualquier controversia se resolverá conforme a las leyes del estado de
          Georgia, EE. UU.
        </p>

        <h3 data-id="element-279" data-mp="1npd6ykau8bzb">11. Contacto</h3>
        <p data-id="element-280" data-mp="1nqoacj0dfhpw">
          Para cualquier duda relacionada con estos términos, comunícate al{' '}
          <a href="tel:+14049409785" data-id="element-281" data-mp="1jpktpuai1hnm">(404) 940-9785</a> o{' '}
          <a href="tel:+16784721588" data-id="element-282" data-mp="1eox3hau3h4ug">(678) 472-1588</a>.
        </p>
      </LegalModal>
    </footer>;
}